import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function Painel() {
  const { usuario } = useAuth();

  // Injeta o script do Webchat Widget (externo, mesmo código do painel.php original)
  useEffect(() => {
    if (!document.getElementById("wc")) {
      (function (w, d, s, o, f, js, fjs) {
        w["WebchatWidget"] = o;
        w[o] =
          w[o] ||
          function () {
            (w[o].q = w[o].q || []).push(arguments);
          };
        w[o].l = 1 * new Date();
        js = d.createElement(s);
        fjs = d.getElementsByTagName(s)[0];
        js.id = o;
        js.src = f;
        js.async = 1;
        fjs.parentNode.insertBefore(js, fjs);
      })(
        window,
        document,
        "script",
        "wc",
        "https://api.apiintegracoes.com/widget.js?t=45f6864a24b0e0f867759601bf7f2eebe69acfad6ca84439b8d0ee337d833d41"
      );
      window.wc("init");
    }

    // Assim que o ChatSDK terminar de carregar, identifica o visitante logado.
    // É isso que permite ao fornecedor amarrar a conversa a um contato
    // conhecido (por e-mail) e, se ele suportar, retomar o histórico entre
    // reloads em vez de tratar cada carregamento como visitante novo.
    let cancelado = false;
    let tentativas = 0;

    const identificar = () => {
      if (cancelado) return;
      if (window.ChatSDK && usuario) {
        window.ChatSDK.identify({
          name: usuario.nome,
          email: usuario.email,
          // phone: usuario.telefone, // descomente se o objeto usuario tiver telefone
        });
        return;
      }
      if (tentativas < 40) {
        // tenta por ~10s (40 x 250ms) enquanto o widget.js ainda carrega
        tentativas += 1;
        setTimeout(identificar, 250);
      }
    };
    identificar();

    return () => {
      cancelado = true;
    };
  }, [usuario]);

  return (
    <section
      className="section"
      style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}
    >
      <div className="container" style={{ maxWidth: "600px" }}>
        <div
          className="card"
          style={{ "--accent": "#22C55E", padding: "40px", textAlign: "center" }}
        >
          <div className="tag">Área logada</div>
          <h1 className="section-title" style={{ fontSize: "28px", marginBottom: "12px" }}>
            Bem-vindo, <span className="text-blue">{usuario?.nome}</span> 👋
          </h1>
          <p className="section-subtitle" style={{ marginBottom: "8px" }}>
            Login realizado com sucesso. Esta é a página de teste protegida.
          </p>
          <p style={{ fontSize: "14px", color: "var(--text-muted)" }}>
            E-mail cadastrado: {usuario?.email}
          </p>
        </div>
      </div>
    </section>
  );
}
